import React from 'react'
import { withTranslation } from 'react-i18next'
import SimpleBar from 'simplebar-react'

import Toggle from 'components/Form/Toggle/Toggle'
import UploadImage from 'components/Form/UploadImage/UploadImage'
import TextInput from 'components/Form/TextInput/TextInput'
import TextArea from 'components/Form/TextArea/TextArea'
import ElementsGroup from 'components/Form/ElementsGroup/ElementsGroup'
import Image from 'components/Form/Image'

import invertColor from '../../../../util/invertColor'
import { checkAndReturnArrayOfErrors } from '../utilities'

class StartView extends React.Component {
    render() {
        const {
            tmpStructure,
            validationStructure,
            tabsValidationResult: { errors },
            methods,
            data: { colorTheme },
            t,
        } = this.props

        return (
            <div className="body">
                <div className="tab-wrapper tab-wrapper--1">
                    <div className="workplace">
                        <SimpleBar autoHide={false} style={{ maxHeight: '100%' }}>
                            <div className="scrollbar-inner">
                                <h3 className="tab-title">
                                    <span>
                                        Start screen
                                        <Toggle
                                            value={tmpStructure._settings.showCover}
                                            onUpdate={v => methods.handleChange__tmpStructure('_settings.showCover', v)}
                                        />
                                    </span>
                                </h3>
                                <div className={`content${!tmpStructure._settings.showCover ? ' is-hidden' : ''}`}>
                                    <TextArea
                                        isRequired={validationStructure._fields['cover.header'].required}
                                        label={t('Header')}
                                        rows={1}
                                        errorMessages={checkAndReturnArrayOfErrors(
                                            errors,
                                            `cover.header`,
                                            t('This field is required'),
                                        )}
                                        value={tmpStructure.cover.header}
                                        onUpdate={value => methods.handleChange__tmpStructure(`cover.header`, value)}
                                    />
                                    <TextArea
                                        isRequired={validationStructure._fields['cover.description'].required}
                                        label={t('Description')}
                                        rows={4}
                                        errorMessages={checkAndReturnArrayOfErrors(
                                            errors,
                                            `cover.description`,
                                            t('This field is required'),
                                        )}
                                        value={tmpStructure.cover.description}
                                        onUpdate={value =>
                                            methods.handleChange__tmpStructure(`cover.description`, value)
                                        }
                                    />
                                    <ElementsGroup>
                                        <UploadImage
                                            label={t('Cover image')}
                                            value={tmpStructure.cover.image}
                                            onUpdate={value => methods.onPlaceImage('cover.image', value)}
                                        />
                                        <TextInput
                                            isRequired={validationStructure._fields['cover.buttonText'].required}
                                            label={t('Button text')}
                                            errorMessages={checkAndReturnArrayOfErrors(
                                                errors,
                                                `cover.buttonText`,
                                                t('This field is required'),
                                            )}
                                            value={tmpStructure.cover.buttonText}
                                            onUpdate={value =>
                                                methods.handleChange__tmpStructure(`cover.buttonText`, value)
                                            }
                                        />
                                    </ElementsGroup>
                                    {tmpStructure.cover.image && (
                                        <TextInput
                                            label={t('Image disclaimer')}
                                            description={'(optional)'}
                                            value={tmpStructure.cover.imageDisclaimer}
                                            onUpdate={value =>
                                                methods.handleChange__tmpStructure(`cover.imageDisclaimer`, value)
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        </SimpleBar>
                    </div>
                    <div className="preview">
                        <SimpleBar autoHide={false} style={{ maxHeight: '100%' }}>
                            <div className="scrollbar-inner">
                                <p className="title">{t('Approximate preview')}</p>
                                <div className={`content${!tmpStructure._settings.showCover ? ' is-hidden' : ''}`}>
                                    {tmpStructure.cover.image ||
                                    tmpStructure.cover.header.length ||
                                    tmpStructure.cover.description.length ||
                                    tmpStructure.cover.buttonText.length ? (
                                        <>
                                            {!!tmpStructure.cover.image && (
                                                <div className="image">
                                                    <Image src={tmpStructure.cover.image} alt="img" />
                                                </div>
                                            )}
                                            {!!tmpStructure.cover.header.length && (
                                                <div className="header">{tmpStructure.cover.header.trim()}</div>
                                            )}
                                            {!!tmpStructure.cover.description.length && (
                                                <div className="description">
                                                    {tmpStructure.cover.description.trim()}
                                                </div>
                                            )}
                                            {!!tmpStructure.cover.buttonText.length && (
                                                <div
                                                    className="button"
                                                    style={{
                                                        backgroundColor: colorTheme,
                                                        color: invertColor(colorTheme, true),
                                                    }}
                                                >
                                                    {tmpStructure.cover.buttonText}
                                                </div>
                                            )}
                                            {tmpStructure.cover.image &&
                                                !!tmpStructure.cover.imageDisclaimer.length && (
                                                    <div className="image-disclaimer">
                                                        {tmpStructure.cover.imageDisclaimer.trim()}
                                                    </div>
                                                )}
                                        </>
                                    ) : (
                                        <p className="empty">{t('You have not entered any data yet')}</p>
                                    )}
                                </div>
                            </div>
                        </SimpleBar>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation('translations')(StartView)
